import { render, staticRenderFns } from "./curriculumProgram.vue?vue&type=template&id=7064cae3&"
import script from "./curriculumProgram.vue?vue&type=script&lang=js&"
export * from "./curriculumProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports